import React from "react";
import {
  IntroSegmentContainer,
  TextSegment,
  HeadingText,
  SubText,
  IntroImageContainer,
  IntroImage,
} from "./styles";
import IntroImagePNG from "../../../../resources/introImage.png";
import Subscriber from "../../../common/Subscriber";
import getString from "../../../../config/strings";

function IntroSegment() {
  return (
    <IntroSegmentContainer>
      <TextSegment>
        <HeadingText>{getString("Home_IntroHeading")}</HeadingText>
        <SubText>{getString("Home_IntroText")}</SubText>
        <Subscriber />
      </TextSegment>
      <IntroImageContainer>
        <IntroImage src={IntroImagePNG} />
      </IntroImageContainer>
    </IntroSegmentContainer>
  );
}
export default IntroSegment;
